/**
 * Vehicle vignette class icons (Slovenia): passenger / motorcycle / larger vehicles.
 * Paths are site-root `/img/svg/` assets.
 */
export const VEHICLE_CATEGORY_ICON_PATHS = {
    /** Car (2A) — standard car class */
    469: '/img/svg/vehicle-class-car-2a.svg',
    /** Motorcycle (A) */
    470: '/img/svg/vehicle-class-motorcycle.svg',
    /** Car (2B) — larger / van class */
    471: '/img/svg/vehicle-class-car-2b.svg'
};

/** @param {string|number|null|undefined} categoryId */
export function getVehicleCategoryIconPath(categoryId) {
    const id = Number(categoryId);
    return VEHICLE_CATEGORY_ICON_PATHS[id] || VEHICLE_CATEGORY_ICON_PATHS[469];
}
